export default __webpack_public_path__ + "static/media/code-life-logo-fr.86a55cf4.png";